import { render } from "./AddNewClient.vue?vue&type=template&id=18ed93fb"
import script from "./AddNewClient.vue?vue&type=script&lang=js"
export * from "./AddNewClient.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__